import { Pipe, PipeTransform } from '@angular/core';
import { DropDownInterface, DropdownItem } from '@com-delta-idp/mnx-ui-kit';

@Pipe({
  name: 'dropdownInputPipe'
})
export class DropdownInputPipe implements PipeTransform {
  transform(itemList: DropDownInterface[]): DropdownItem[] {
    const optionItemArray: DropdownItem[] = [];
    if (itemList && itemList.length > 0) {
      itemList.forEach((item) => {
        let itemToPush: DropdownItem;
        if (item.code && item.description) {
          itemToPush = {
            label: item.description,
            value: item.code
          };
          optionItemArray.push(itemToPush);
        }
      });
    }
    return optionItemArray;
  }
}
